export const headerMenuList = {
  color: '#fff',
  textDecoration: 'none',
  fontSize: '1rem',
  padding: '0.5rem 1rem',
};

export const menuText = {
  color: 'rgba(255,255,255,.55)',
  textDecoration: 'none',
  fontSize: '1rem',
  padding: '0.5rem 1rem',
};

export const dropDownText = {
  color: 'rgba(255,255,255,.55)',
  cursor: 'pointer',
};

export const dropDownDiv = {
  position: 'fixed',
  top: '3rem',
  zIndex: '1000',
  minWidth: ' 10rem',
  margin: '0',
  fontSize: '1rem',
  color: '#212529',
  textAlign: 'left',
  listStyle: 'none',
  backgroundColor: ' #fff',
  backgroundClip: 'padding-box',
  border: '0.06rem solid rgba(0,0,0,.15)',
  borderRadius: ' 0.25rem',
};

export const dropDownList = {
  textDecoration: 'none',
  display: 'block',
  width: '100%',
  padding: '0.25rem 1rem',
  clear: 'both',
  fontWeight: '400',
  color: '#212529',
  textAlign: 'inherit',
  whiteSpace: 'nowrap',
  backgroundColor: 'transparent',
  border: '0',
};

export const logoutGrid = {
  height: '4rem',
  display: 'flex',
  alignItems: 'center',
};

export const userNameGrid = {
  marginBottom: '16px',
  fontSize: '24px',
  fontWeight: 'normal',
  color: 'black',
};

export const logoutIconStyle = {
  color: 'black',
  fontSize: '18px',
};

export const logoutCard = {
  minWidth: 250,
  border: '2px solid gray',
};
